module.exports = __webpack_public_path__ + "media/src/application/media/v2-icon-5-3f4be9269ae1d1657f2e1c14b620d01f.svg";